// Absolute URL of a link-preview image from pages/api/og. Kept apart from
// cards.tsx so pages can import it without pulling sharp into the bundle.
// Bump OG_VERSION after changing a card design: platforms cache by URL.
export const OG_VERSION = 1;

export const ogUrl = (p: string) =>
  `https://www.jammable.com/api/og/${p}?v=${OG_VERSION}`;

export const ogImage = (p: string, alt: string) => ({
  url: ogUrl(p),
  width: 1200,
  height: 630,
  alt,
});
